const initialState = {
	loadingAlerts: false,
}

/** Pinia store for guest email-alert subscriptions (lottery result notifications without an account). */
export const useSubscriberStore = defineStore('subscriber', {
	state: () => ({ ...initialState }),
	actions: {
		/** Sets any top-level state property by key. */
		SET_STATE_SUBSCRIBER({ type, value }) {
			this[type] = value
		},
		/** Registers a new email alert subscription. */
		async saveSubscriber(body) {
			const { $repository } = useNuxtApp()
			const response = await $repository.v1.subscriber.postSubscriberRegister(body)
			return response
		},
		/** Checks if the given email is already subscribed for the lottery/country combination. */
		async validateSubscriber(body) {
			const { $repository } = useNuxtApp()
			this.loadingAlerts = true
			const response = await $repository.v1.subscriber.postValidateSubscriber(body)
			this.loadingAlerts = false
			return response
		},
	},
})
